import React, { useEffect, useState } from "react";
import { Card, Input, Button, Flex, Checkbox, Select, Popconfirm } from "antd";
import {
  useCreateAllergyMutation,
  useFetchAllergyByIdQuery,
  useFetchAllergyQuery,
  useUpdateAllergyMutation,
  useDeleteAllergyMutation,
} from "./allergy.service";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "./style.css";

const allergyType = [
  "celery",
  "gluten",
  "crustaceans",
  "eggs",
  "fish",
  "lupin",
  "milk",
  "molluscs",
  "mustard",
  "nuts",
  "peanuts",
  "sesame seeds",
  "soya",
  "sulphur dioxide",
];

export default function AllergyEdit() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const navigate = useNavigate();

  const [allergyId, setAllergyId] = useState();
  const [allergyUpdate, setAllergyUpdate] = useState([]);

  const { data: dishData = [], isSuccess: isFetchSuccess } =
    useFetchAllergyQuery();
  const [requestUpdateAllergy, { isSuccess }] = useUpdateAllergyMutation();
  const [requestDeleteAllergy, { isSuccess: isDeleteSuccess }] =
    useDeleteAllergyMutation();

  const handleCreateAllergy = () => {
    if (!allergyId) {
      toast.error("Select a dish");
      return;
    }

    if (!allergyUpdate) {
      toast.error("Select the allergy item");
      return;
    }

    requestUpdateAllergy({
      id: allergyId,
      data: { allergens: allergyUpdate },
    });
  };

  const handleAllergy = (e) => {
    setAllergyId(e);
    setAllergyUpdate([
      ...dishData.filter((item) => item._id === e)[0].allergens,
    ]);
  };

  const handleDeleteAllergy = () => {
    if (!allergyId) {
      toast.error("Select a dish");
      return;
    }
    requestDeleteAllergy(allergyId);
  };

  useEffect(() => {
    if (isSuccess) {
      setAllergyUpdate([]);
      setAllergyId();
      navigate("/allergy");
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isDeleteSuccess) {
      toast.success("Allergy deleted successfully");
      navigate("/allergy");
    }
  }, [isDeleteSuccess]);

  return (
    <Card
      title={`${t("ALLERGY")} ${t("UPDATE")}`}
      className="allergy-create-page"
      extra={
        <Flex justify="center" gap={10}>
          <Button onClick={() => navigate("/allergy")}>{t("CANCEL")}</Button>
          <Button type="primary" onClick={handleCreateAllergy}>
            {t("UPDATE")}
          </Button>
          {allergyId && (
            <Popconfirm
              title={t("DELETE_CONFIRMATION")}
              description={t("ARE_YOU_SURE_DELETE")}
              onConfirm={handleDeleteAllergy}
              okText={t("YES")}
              cancelText={t("NO")}
            >
              <Button danger>{t("DELETE")}</Button>
            </Popconfirm>
          )}
        </Flex>
      }
    >
      <div className="allergy-create-page-container">
        <div className="allergy-create-page-container-dish">
          <div>{t("DISH")}</div>
          <Select
            style={{ minWidth: "400px", marginLeft: "16px" }}
            showSearch
            placeholder="Select a dish"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={dishData.reduce((arr, cur) => {
              arr.push({
                label: cur[`name_${language}`],
                value: cur._id,
              });
              return arr;
            }, [])}
            onSelect={handleAllergy}
          />
        </div>
        <div className="allergy-create-page-container-allergy">
          <div className="allergy-create-page-container-allergy-label">
            {t("ALLERGY")}
          </div>
          <div className="allergy-create-page-container-allergy-grid">
            <div className="allergy-create-page-container-allergy-grid-item">
              {allergyType.slice(0, 7).map((item, key) => (
                <div
                  key={key}
                  className="allergy-create-page-container-allergy-grid-item"
                >
                  <Checkbox
                    checked={allergyUpdate.includes(item) ? true : false}
                    onClick={(cbox) => {
                      cbox.target.checked
                        ? setAllergyUpdate((e) => [...e, item])
                        : setAllergyUpdate((e) =>
                            e.filter((aItem) => aItem !== item)
                          );
                    }}
                  >
                    {t(item.toUpperCase())}
                  </Checkbox>
                </div>
              ))}
            </div>
            <div className="allergy-create-page-container-allergy-grid-item">
              {allergyType.slice(7, 14).map((item, key) => (
                <div
                  key={key}
                  className="allergy-create-page-container-allergy-grid-item"
                >
                  <Checkbox
                    checked={allergyUpdate.includes(item) ? true : false}
                    onClick={(cbox) =>
                      cbox.target.checked
                        ? setAllergyUpdate((e) => [...e, item])
                        : setAllergyUpdate((e) =>
                            e.filter((aItem) => aItem !== item)
                          )
                    }
                  >
                    {t(item.toUpperCase())}
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="allergy-create-page-container-button">
          <Button type="primary" onClick={handleCreateAllergy}>
            {t("UPDATE")}
          </Button>
        </div>
      </div>
    </Card>
  );
}
